// eslint-disable-next-line no-restricted-syntax
export enum AnalyticsType {
  CORPORATE_FLEX = "CORPORATE_FLEX",
  WORKPLACE_FLEX = "WORKPLACE_FLEX",
}

export const ANALYTICS_TYPE_TITLES: Record<AnalyticsType, string> = {
  [AnalyticsType.CORPORATE_FLEX]: "Corporate Analytics",
  [AnalyticsType.WORKPLACE_FLEX]: "Workplace Analytics",
};

export const EXPLO_ORIGIN = "https://app.explo.co";

export const EXPLO_EVENTS = {
  CUSTOMER_JWT_EXPIRED: "customerJwtExpired",
  UPDATE_CUSTOMER_JWT: "updateCustomerJwt",
  DASHBOARD_FAILED: "dashboardFailed",
  ERROR: "error",
} as const;
